import AccountingDashboardStore from "./Dashboard/AccountingDashboard.Store";
import BillsStore from "./Purchases/Bills/Bills.Store";
import InvoicesStore from "./Sales/Invoices/Invoices.Store";
import PaymentsStore from "./Payments/Payments.Store";
import { POConversionViewStore } from "./po-conversion/stores/POConversionViewStore";
import { InvoiceConversionViewStore } from "./invoice-conversion/stores/InvoiceConversionViewStore";
import ChartOfAccountsStore from "./ChartOfAccounts/ChartOfAccounts.Store";
import JournalEntriesStore from "./JournalEntries/JournalEntries.Store";
import JobCostingStore from "./JobCosting/JobCosting.Store";
import ProductionCostsStore from "./ProductionCosts/ProductionCosts.Store";
import FinancialReportsStore from "./Reports/FinancialReports/FinancialReports.Store";
import AutomationWorkflowsStore from "./AutomationWorkflows/AutomationWorkflows.Store";
import AdvancedFeaturesStore from "./AdvancedFeatures/AdvancedFeatures.Store";
import ReceivingQueueStore from "./ReceivingQueue/ReceivingQueue.Store";
import ApprovalQueueStore from "./ApprovalQueue/ApprovalQueue.Store";
import PaymentQueueStore from "./PaymentQueue/PaymentQueue.Store";
import PurchaseOrdersStore from "./PurchaseOrders/PurchaseOrders.Store";
import TaskWorkflowStore from "./TaskWorkflow/TaskWorkflow.Store";
import InvoiceManagementStore from "./Invoices/Invoices.Store";
import AccountsPayableStore from "./AccountsPayable/AccountsPayable.Store";
import AccountsReceivableStore from "./AccountsReceivable/AccountsReceivable.Store";
import FreightMatchingStore from "./FreightMatching/FreightMatching.Store";
import AssetTransactionsStore from "./AssetTransactions/AssetTransactions.Store";
import CheckPrintingStore from "./CheckPrinting/CheckPrinting.Store";
import CheckTemplateDesignerStore from "./CheckTemplateDesigner/CheckTemplateDesigner.Store";
import RecurringTransactionsStore from "./RecurringTransactions/RecurringTransactions.Store";
import FiscalPeriodsStore from "./FiscalPeriods/FiscalPeriods.Store";
import GeneralLedgerStore from "./GeneralLedger/GeneralLedger.Store";
import ReconciliationStore from "./Reconciliation/Reconciliation.Store";
import { ACCOUNTING_APP_STORES } from "@intrasync/accounting";

const accountingStoreList = [
  // AccountingHub view/data stores from @intrasync/accounting
  ...ACCOUNTING_APP_STORES,
  { name: "accountingDashboardStore", store: AccountingDashboardStore },
  { name: "billsViewStore", store: BillsStore },
  { name: "invoicesViewStore", store: InvoicesStore },
  { name: "paymentsViewStore", store: PaymentsStore },
  { name: "poConversionViewStore", store: POConversionViewStore },
  { name: "invoiceConversionViewStore", store: InvoiceConversionViewStore },
  { name: "chartOfAccountsViewStore", store: ChartOfAccountsStore },
  { name: "journalEntriesViewStore", store: JournalEntriesStore },
  { name: "jobCostingViewStore", store: JobCostingStore },
  { name: "productionCostsViewStore", store: ProductionCostsStore },
  { name: "financialReportsViewStore", store: FinancialReportsStore },
  { name: "automationWorkflowsViewStore", store: AutomationWorkflowsStore },
  { name: "advancedFeaturesViewStore", store: AdvancedFeaturesStore },
  { name: "receivingQueueStore", store: ReceivingQueueStore },
  { name: "approvalQueueStore", store: ApprovalQueueStore },
  { name: "paymentQueueStore", store: PaymentQueueStore },
  { name: "purchaseOrdersViewStore", store: PurchaseOrdersStore },
  { name: "taskWorkflowStore", store: TaskWorkflowStore },
  { name: "invoiceManagementStore", store: InvoiceManagementStore },
  { name: "accountsPayableStore", store: AccountsPayableStore },
  { name: "accountsReceivableStore", store: AccountsReceivableStore },
  { name: "freightMatchingStore", store: FreightMatchingStore },
  { name: "assetTransactionsStore", store: AssetTransactionsStore },
  { name: "checkPrintingStore", store: CheckPrintingStore },
  { name: "checkTemplateDesignerStore", store: CheckTemplateDesignerStore },
  { name: "recurringTransactionsStore", store: RecurringTransactionsStore },
  { name: "fiscalPeriodsViewStore", store: FiscalPeriodsStore },
  { name: "generalLedgerStore", store: GeneralLedgerStore },
  { name: "reconciliationStore", store: ReconciliationStore },
];

export default accountingStoreList;
